import { SubscriptionClient } from '@skyscanner-internal/global-components/login-form/helpers';

import { logError } from '../../helpers/logger';

import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

let subscriptionClient: Nullable<SubscriptionClient> = null;

const setSubscriptionClient = (): void => {
  subscriptionClient = new SubscriptionClient();
};

const getSubscriptionClient = () => {
  if (subscriptionClient === null) {
    const error = new Error('Subscription client is not set.');
    logError({
      error,
      component: 'SubscriptionClient',
      message: 'Error getting instance of subscription client',
    });
  }
  return subscriptionClient;
};

export { getSubscriptionClient, setSubscriptionClient };
